import { render, staticRenderFns } from "./Temperatures.vue?vue&type=template&id=7cf14a5a&scoped=true"
import script from "./Temperatures.vue?vue&type=script&lang=js"
export * from "./Temperatures.vue?vue&type=script&lang=js"
import style0 from "./Temperatures.vue?vue&type=style&index=0&id=7cf14a5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf14a5a",
  null
  
)

export default component.exports